import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send, Facebook, Instagram, Twitter } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    recipient: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="w-full bg-gray-50 min-h-screen" data-id="element-655">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#0E578E] to-[#01AAE7] py-16 sm:py-20 overflow-hidden" data-id="element-656">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10" data-id="element-657">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-658"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-659"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10 text-center" data-id="element-660">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-4 leading-tight" data-id="element-661">
            Contact Us
          </h1>
          <p className="text-lg sm:text-xl text-white/90 leading-relaxed max-w-2xl mx-auto" data-id="element-662">
            Have a question - we're here to help.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12 sm:py-16 lg:py-20" data-id="element-663">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-664">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-665">
            {/* Left Column - Contact Form */}
            <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6 sm:p-8 lg:p-10" data-id="element-666">
              <h2 className="text-2xl sm:text-3xl font-black text-gray-900 mb-6" data-id="element-667">
                Send us a Message
              </h2>

              <form onSubmit={handleSubmit} className="space-y-5" data-id="element-668">
                {/* First Name */}
                <div data-id="element-669">
                  <label htmlFor="firstName" className="block text-sm font-bold text-gray-700 mb-2" data-id="element-670">
                    First Name*
                  </label>
                  <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} required className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:bg-white text-gray-900 transition-all" data-id="element-671" />
                </div>

                {/* Last Name */}
                <div data-id="element-672">
                  <label htmlFor="lastName" className="block text-sm font-bold text-gray-700 mb-2" data-id="element-673">
                    Last Name*
                  </label>
                  <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} required className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:bg-white text-gray-900 transition-all" data-id="element-674" />
                </div>

                {/* Email */}
                <div data-id="element-675">
                  <label htmlFor="email" className="block text-sm font-bold text-gray-700 mb-2" data-id="element-676">
                    Email*
                  </label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:bg-white text-gray-900 transition-all" data-id="element-677" />
                </div>

                {/* Phone */}
                <div data-id="element-678">
                  <label htmlFor="phone" className="block text-sm font-bold text-gray-700 mb-2" data-id="element-679">
                    Phone
                  </label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:bg-white text-gray-900 transition-all" data-id="element-680" />
                </div>

                {/* Message Recipient */}
                <div data-id="element-681">
                  <label htmlFor="recipient" className="block text-sm font-bold text-gray-700 mb-2" data-id="element-682">
                    Select Message Recipient*
                  </label>
                  <select id="recipient" name="recipient" value={formData.recipient} onChange={handleChange} required className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:bg-white text-gray-900 transition-all appearance-none cursor-pointer" data-id="element-683">
                    <option value="" data-id="element-684">Please choose a recipient</option>
                    <option value="support" data-id="element-685">Support</option>
                    <option value="sales" data-id="element-686">Sales</option>
                    <option value="general" data-id="element-687">General Inquiry</option>
                  </select>
                </div>

                {/* Message */}
                <div data-id="element-688">
                  <label htmlFor="message" className="block text-sm font-bold text-gray-700 mb-2" data-id="element-689">
                    Message*
                  </label>
                  <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={6} className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:bg-white text-gray-900 transition-all resize-none" data-id="element-690"></textarea>
                </div>

                {/* Submit Button */}
                <button type="submit" className="group w-full px-6 py-4 bg-gradient-to-r from-[#01AAE7] to-[#0199d6] text-white font-bold rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-691">
                  <span data-id="element-692">Submit</span>
                  <Send className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-693" />
                </button>
              </form>
            </div>

            {/* Right Column - Contact Info */}
            <div className="bg-gradient-to-br from-[#0E578E] to-[#01AAE7] rounded-2xl shadow-xl p-6 sm:p-8 lg:p-10 text-white" data-id="element-694">
              <h2 className="text-2xl sm:text-3xl font-black mb-8" data-id="element-695">Info</h2>

              <div className="space-y-8" data-id="element-696">
                {/* Company Name */}
                <div data-id="element-697">
                  <h3 className="text-xl font-bold mb-2" data-id="element-698">RaceLookup™</h3>
                </div>

                {/* Address */}
                <div className="flex items-start gap-4" data-id="element-699">
                  <div className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-700">
                    <MapPin className="h-6 w-6" data-id="element-701" />
                  </div>
                  <div data-id="element-702">
                    <h4 className="font-bold mb-1" data-id="element-703">Address</h4>
                    <p className="text-white/90 leading-relaxed" data-id="element-704">
                      207 West Clarendon Avenue Unit 17A
                      <br data-id="element-705" />
                      Phoenix, AZ 85013-3441
                    </p>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start gap-4" data-id="element-706">
                  <div className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-707">
                    <Mail className="h-6 w-6" data-id="element-708" />
                  </div>
                  <div data-id="element-709">
                    <h4 className="font-bold mb-1" data-id="element-710">Email</h4>
                    <a href="mailto:support@racelookup.com" className="text-white/90 hover:text-white transition-colors" data-id="element-711">
                      support@racelookup.com
                    </a>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex items-start gap-4" data-id="element-712">
                  <div className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-713">
                    <Phone className="h-6 w-6" data-id="element-714" />
                  </div>
                  <div data-id="element-715">
                    <h4 className="font-bold mb-1" data-id="element-716">Phone</h4>
                    <a href="tel:602.464.4719" className="text-white/90 hover:text-white transition-colors block" data-id="element-717">
                      602.464.4719
                    </a>
                  </div>
                </div>

                {/* Social Media */}
                <div data-id="element-718">
                  <h4 className="font-bold mb-4" data-id="element-719">Follow Us</h4>
                  <div className="flex gap-4" data-id="element-720">
                    <a href="#" className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-xl flex items-center justify-center hover:bg-white/20 transition-all" aria-label="Facebook" data-id="element-721">
                      <Facebook className="h-6 w-6" data-id="element-722" />
                    </a>
                    <a href="#" className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-xl flex items-center justify-center hover:bg-white/20 transition-all" aria-label="Instagram" data-id="element-723">
                      <Instagram className="h-6 w-6" data-id="element-724" />
                    </a>
                    <a href="#" className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-xl flex items-center justify-center hover:bg-white/20 transition-all" aria-label="Twitter" data-id="element-725">
                      <Twitter className="h-6 w-6" data-id="element-726" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}